export enum DocFormEnum {
    Email = "email",
    AccountNo = "accountNo"
}
